export const manufacturerAction = {
  setManufacturers: (state, action) => {
    state.manufacturers = action.payload;
  },
};
